import React from 'react';
import { TourContainer } from './TourContainer';
import { SidebarCol } from '../chatMain/Sidebar/Sidebar';
import { MainHeader } from "../chatMain/MainHeader/MainHeader";

export const TourPage = () => {
  // Since TourContainer needs props, but for now, assume it can handle without or pass dummy props
  // Actually, TourContainer needs progress, isStepBlurred, and handlers
  // For the tour page, we might need to get these from context or state
  // For simplicity, let's assume we pass empty or default values, or use hooks

  // But to make it work, perhaps import useState and set defaults

  const [progress, setProgress] = React.useState({
    chat: false,
    mindfulness: false,
    assessment: false,
    live: false,
    courses: false,
  });

  const isStepBlurred = (step) => {
    return !(progress[step] || step === 'assessment'); // example
  };

  const handleBeginAssessment = () => {};
  const handleBeginChat = () => {};
  const handleBeginMindful = () => {};
  const handleBeginLive = () => {};
  const handleBeginCourse = () => {};

  return (
    <>
      <div className="tour-page-container">
        <div className="tour-sidebar">
          <SidebarCol />
        </div>
        <div className="tour-main">
          <div style={{ position: "sticky", top: 0, zIndex: 1000 }}>
            <MainHeader titleText="Tour" subtitleText="Explore our features" />
          </div>
          <TourContainer
            progress={progress}
            isStepBlurred={isStepBlurred}
            handleBeginAssessment={handleBeginAssessment}
            handleBeginChat={handleBeginChat}
            handleBeginMindful={handleBeginMindful}
            handleBeginLive={handleBeginLive}
            handleBeginCourse={handleBeginCourse}
          />
        </div>
      </div>
    </>
  );
};